export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n3_appartenance-horizontale.f3949ed0.svg";